import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomRedirect = ({ to }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to);
  }, [to, navigate]);

  return null;
};

export default CustomRedirect;
